import React, {FC, PropsWithChildren} from 'react';

type Props = {
  useLightFont?: boolean;
};

export const DataTextBody: FC<PropsWithChildren<Props>> = ({useLightFont, children}) => (
  <h4 className={`${useLightFont ? 'fontBook' : 'fontMain font-bold'} whitespace-normal`}>{children}</h4>
);
